import moment from 'moment';

function FormatBankTxState() {
    return function(value) {
        if (value === 'approved') {
            return 'Aprobada';
        } else if (value === 'draft') {
            return 'Pendiente aprobación';
        } else {
            return '';
        }
    };
}

export default FormatBankTxState;
